// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PAm7","label":"styles_label__Y8yma"};